// select input reaact component
import React, {
  HTMLProps,
  MouseEvent, useEffect, useRef, useState
} from 'react';

import '../../../styles/select-style.scss';

interface SelectProps extends HTMLProps<HTMLSelectElement> {
  handleChange: (option: { id: string; label: string }) => void;
  id: string;
  label: string;
  options: OptionsProps[];
  required?: boolean;
  // TODO: fix this use of any
  handleClickableOption?: (value: MouseEvent<HTMLLIElement>) => void;
  clickableText?: string;
  selectedOption?: { id: string; label: string };
}

interface OptionsProps extends HTMLProps<HTMLOptionsCollection> {}

export function Select({
  id,
  label,
  required,
  options,
  selectedOption,
  handleChange,
  handleClickableOption,
  clickableText
}: SelectProps) {
  const [ isOpen, setIsOpen ] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (event.target.id === 'default-option') {
        setTimeout(() => setIsOpen(false), 1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    handleChange(option);
    setIsOpen(false);
  };
  console.log('Select', options, selectedOption);

  return (
    <div className="dropdown-container input" ref={dropdownRef}>
      {label && (
        <label htmlFor={id} className="input-label">
          {label}
          {required && <span className="required-indicator">*</span>}
        </label>
      )}

      <button id={id} className="dropdown-button" onClick={() => setIsOpen(!isOpen)} type="button">
        {selectedOption ? selectedOption.label : 'Select an option'}
        <span className="arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <ul className="dropdown-list">
          {options.map((option, idx) => (
            <li
              key={idx}
              className={`dropdown-item ${option.id === selectedOption?.id ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
          {!!handleClickableOption && (
            <li id="default-option" className="dropdown-item" onClick={handleClickableOption}>
              {clickableText}
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
